import React from "react";
import { Link, useLocation } from "react-router-dom";

const TaskBar = () => {
	const TaskBarItems = [
		{
			title: 'Home',
			link: "/",
			icon: "fas fa-home",
		},
		{
			title: 'About Me',
			link: "/about",
			icon: "far fa-address-card",
		},
		{
			title: 'Skills & Experience',
			link: "/skills-experience",
			icon: "fas fa-laptop-code",
		},
		{
			title: 'Projects',
			link: "/projects",
			icon: "fas fa-project-diagram",
		},
		{
			title: 'Contact Me',
			link: "/contact",
			icon: "far fa-address-book",
		},
	]

	const IsActive = (route) => useLocation().pathname === route;
	
	const renderTaskBar = () => {
		return TaskBarItems.map((item) => {
			return (
				<Link to={item.link} title={item.title} className={IsActive(item.link) ? 'active' : ''} key={item.title}>
					<i className={item.icon} />
				</Link>
			);
		});
	};

	return (
		<div className="task-bar">
			<div className="items">
				{renderTaskBar()}
			</div>
		</div>
	);
};

export default TaskBar;
